import React, { useContext } from "react";
import Logo from "@common/components/Logo";
import Typography from "@common/components/Typography";
import { Stack } from "@mui/material";
import { account_logo } from "@assets/images";
import { useTranslation } from "react-i18next";
import OidInfos from "./OidInfos";
import AdapterInfos from "./AdapterInfos";
import { ReducerContext } from "../../context";
import MappingInfo from "./MappingInfo";

interface DeviceInfosProps {
  refetchDevices: () => void;
}

const DeviceInfos = ({ refetchDevices }: DeviceInfosProps) => {
  const { device, accountId, canEdit } = useContext(ReducerContext);
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: "space-around",
        alignItems: "center",
        px: 2
      }}>
      <Logo
        objectId={device.model}
        logoClass="DeviceModel"
        isEdit
        logo={device?.logo}
        defaultimage={account_logo}
        disabled={!canEdit}
        refetchAsset={refetchDevices}
      />
      <Stack>
        <Typography>
          {t("Manufacturer : {{manufacturer}}", {
            manufacturer: device.manufacturer,
          })}
        </Typography>
        <Typography>
          {t("Category : {{category}}", { category: device.category })}
        </Typography>
        <Typography>
          {t("Device Type : {{deviceType}}", {
            deviceType: device.deviceType,
          })}
        </Typography>
        {device.family && (
          <Typography>
            {t("Family : {{family}}", {
              family: device.family,
            })}
          </Typography>
        )}
        {accountId && <OidInfos />}
        {device.totalAdapters !== 0 && <AdapterInfos />}
        <MappingInfo />
      </Stack>
    </Stack>
  );
};

export default DeviceInfos;
